import React from 'react';

import Typography from '@material-ui/core/Typography';

interface IFieldCaptionProps {
  id?: string;
  // Pulls the caption up and in so it sits under a checkbox's label text rather
  // than under the checkbox itself. Inputs use the default flow position.
  underCheckbox?: boolean;
  children: React.ReactNode;
}

export const FieldCaption: React.FC<IFieldCaptionProps> = ({ id, underCheckbox = false, children }) => (
  <Typography
    id={id}
    variant="caption"
    color="textSecondary"
    style={underCheckbox
      ? { display: 'block', marginLeft: '2rem', marginTop: '-0.625rem' }
      : { display: 'block', marginTop: '0.25rem', lineHeight: 1.4 }}
  >
    {children}
  </Typography>
);
